import { ArrowRight } from "lucide-react";

import type { OtcOrder } from "../../types/cryptoSwaps.types";
import { AssetAmount } from "./AssetAmount";
import { AssetAvatar } from "./CryptoSwapBits";

export function OrderAmounts({ order, size = "xs" }: { order: OtcOrder; size?: "xs" | "sm" }) {
  return (
    <span className="inline-flex flex-wrap items-center gap-2 font-mono text-[13px]">
      <span>
        <AssetAmount
          value={order.send.amount}
          currency={order.send.currency}
          size={size}
          className="font-normal"
        />{" "}
        {order.send.currency}
      </span>
      <ArrowRight aria-hidden="true" className="size-3 text-muted-foreground" />
      <span className="inline-flex items-center gap-1.5 font-semibold">
        <AssetAvatar asset={order.receive.currency} kind="ONCHAIN" size="xs" />
        <AssetAmount
          value={order.receive.amount}
          currency={order.receive.currency}
          size={size}
          className="font-semibold"
        />{" "}
        {order.receive.currency}
      </span>
    </span>
  );
}
